jQuery(function($){

  $('<span class="badge badge-alert">3</span>').prependTo('.menu-item-18');

	function getPosts() {

	}

	/*
		* get last update date of if exists
		** not exists
		*** getpostscount
		*** setreadposts
		*** 
		*** show updatenumber
		** exists
		*** check if update needed
		*
	 */
   function getLastReadTime() {
// ajax call
    return sessionStorage.setItem("getLastReadTime", 10);
   }

   function getPostCount() {
// ajax call
    return sessionStorage.setItem("getPostsCount", 10);
   }

   function getReadCount() {
// ajax call
    return localStorage.setItem("getReadCount", 10);
   }


  // check if session storage exists
  if(sessionStorage) {
    // get data and at to browsersession
    if(!sessionStorage.getItem("getLastReadTime")) {
      getPostCount();
      getReadCount();






      // jQuery.get( "/?control=WindFarm_Data", function( aData ) {
      //     sessionStorage.setItem("aMarker", JSON.stringify(aData.aMarker));
      //     var data = aData.aInfo;
      //     for (var key in data) {
      //        if (data.hasOwnProperty(key)) {
      //           sessionStorage.setItem("windmill_" + key, data[key]);
      //        }
      //     }
      //     AddMarkersOnMap();
      // });
    }
  }


});